import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';

export type ROIFilters = {
  endDate?: string;
  locationIds?: string[];
  startDate?: string;
};

interface ROIStore {
  defaultFilters?: ROIFilters;
  definitionsHelperDateRange?: string;
  doNotOverrideFiltersOnLoad?: boolean;
  filterHintText?: string;
  filters?: ROIFilters;

  setDefaultFilters: (defaultFilters: Partial<ROIFilters>) => void;
  setDefinitionsHelperDateRange: (definitionsHelperDateRange?: string) => void;
  setDoNotOverrideFiltersOnLoad: (doNotOverrideFiltersOnLoad?: boolean) => void;
  setFilterHintText: (filterHintText?: string) => void;
  setFilters: (filters: Partial<ROIFilters>) => void;

  resetStore: () => void;
}

const filtersPlaceholder = {
  endDate: '',
  locationIds: [],
  startDate: '',
};

const initialValues = {
  defaultFilters: filtersPlaceholder,
  definitionsHelperDateRange: '',
  doNotOverrideFiltersOnLoad: false,
  filterHintText: '',
  filters: filtersPlaceholder,
  selectedRoiLocationIds: [],
};

const useARRoiStore = createStoreWithSubscribe<ROIStore>(
  (set, get) => ({
    ...initialValues,

    setDefaultFilters: (defaultFilters) => {
      set({ defaultFilters });
    },

    setDefinitionsHelperDateRange: (definitionsHelperDateRange) => {
      set({ definitionsHelperDateRange });
    },

    setDoNotOverrideFiltersOnLoad: (doNotOverrideFiltersOnLoad) => {
      set({ doNotOverrideFiltersOnLoad });
    },

    setFilterHintText: (filterHintText) => {
      set({ filterHintText });
    },

    setFilters: (filters) => {
      const filtersCopy = { ...get().filters, ...filters };
      set({ filters: filtersCopy });
    },

    resetStore: () => {
      set({ ...initialValues });
    },
  }),
  {
    name: 'ROIStore',
    trace: true,
  }
);

export const useARRoiShallowStore = createShallowStore<ROIStore>(useARRoiStore);
